<template>
  <svg
    viewBox="0 0 120 120"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    class="size-full"
  >
    <!-- Background blob -->
    <ellipse
      cx="60"
      cy="60"
      rx="50"
      ry="48"
      fill="currentColor"
      opacity="0.04"
      stroke="none"
    />

    <!-- Clipboard body -->
    <rect
      x="24"
      y="20"
      width="52"
      height="72"
      rx="5"
      ry="5"
      stroke-width="2"
    />
    <rect
      x="24"
      y="20"
      width="52"
      height="72"
      rx="5"
      ry="5"
      fill="currentColor"
      opacity="0.05"
      stroke="none"
    />

    <!-- Clipboard clip at top -->
    <rect
      x="40"
      y="14"
      width="20"
      height="12"
      rx="3"
      ry="3"
      stroke-width="2"
    />
    <rect
      x="40"
      y="14"
      width="20"
      height="12"
      rx="3"
      ry="3"
      fill="currentColor"
      opacity="0.07"
      stroke="none"
    />

    <!-- Clipboard clip hole -->
    <circle
      cx="50"
      cy="18"
      r="2"
      stroke-width="1.5"
    />

    <!-- Checklist items -->
    <!-- Item 1 — checked -->
    <rect
      x="30"
      y="34"
      width="8"
      height="8"
      rx="2"
      stroke-width="1.5"
      fill="currentColor"
      opacity="0.07"
    />
    <path
      d="M32 38.5 L34 40.5 L37 36"
      stroke-width="2"
      opacity="0.4"
    />
    <line
      x1="42"
      y1="38"
      x2="66"
      y2="38"
      stroke-width="1.5"
      opacity="0.3"
    />

    <!-- Item 2 — checked -->
    <rect
      x="30"
      y="48"
      width="8"
      height="8"
      rx="2"
      stroke-width="1.5"
      fill="currentColor"
      opacity="0.07"
    />
    <path
      d="M32 52.5 L34 54.5 L37 50"
      stroke-width="2"
      opacity="0.4"
    />
    <line
      x1="42"
      y1="52"
      x2="62"
      y2="52"
      stroke-width="1.5"
      opacity="0.3"
    />

    <!-- Item 3 — in progress (no check) -->
    <rect
      x="30"
      y="62"
      width="8"
      height="8"
      rx="2"
      stroke-width="1.5"
      fill="currentColor"
      opacity="0.04"
    />
    <line
      x1="42"
      y1="66"
      x2="68"
      y2="66"
      stroke-width="1.5"
      opacity="0.2"
    />

    <!-- Item 4 — pending -->
    <rect
      x="30"
      y="76"
      width="8"
      height="8"
      rx="2"
      stroke-width="1.5"
      fill="currentColor"
      opacity="0.03"
    />
    <line
      x1="42"
      y1="80"
      x2="58"
      y2="80"
      stroke-width="1.5"
      opacity="0.12"
    />

    <!-- Decorative route/path element — winding road on right side -->
    <path
      d="M86 30
         C90 36 84 44 88 50
         C92 56 86 64 90 70
         C93 74 91 77 92 79"
      stroke-width="2.5"
      opacity="0.15"
      fill="none"
    />

    <!-- Route waypoint dots -->
    <circle
      cx="86"
      cy="30"
      r="3"
      fill="currentColor"
      opacity="0.12"
      stroke-width="1.5"
    />
    <circle
      cx="86"
      cy="30"
      r="1"
      fill="currentColor"
      opacity="0.2"
      stroke="none"
    />

    <circle
      cx="88"
      cy="50"
      r="3"
      fill="currentColor"
      opacity="0.1"
      stroke-width="1.5"
    />
    <circle
      cx="88"
      cy="50"
      r="1"
      fill="currentColor"
      opacity="0.15"
      stroke="none"
    />

    <circle
      cx="90"
      cy="70"
      r="3"
      fill="currentColor"
      opacity="0.1"
      stroke-width="1.5"
    />
    <circle
      cx="90"
      cy="70"
      r="1"
      fill="currentColor"
      opacity="0.15"
      stroke="none"
    />

    <!-- Destination pin -->
    <path
      d="M92 91 C92 91 87 86 87 83.5 C87 80.5 89.2 79 92 79 C94.8 79 97 80.5 97 83.5 C97 86 92 91 92 91 Z"
      fill="currentColor"
      fill-opacity="0.08"
      stroke-opacity="0.2"
      stroke-width="1.5"
    />
    <circle
      cx="92"
      cy="83.5"
      r="1.5"
      fill="currentColor"
      opacity="0.2"
      stroke="none"
    />

    <!-- Small star/sparkle suggesting personalization -->
    <g
      opacity="0.15"
      transform="translate(98, 36)"
    >
      <line
        x1="0"
        y1="-5"
        x2="0"
        y2="5"
        stroke-width="1.5"
      />
      <line
        x1="-5"
        y1="0"
        x2="5"
        y2="0"
        stroke-width="1.5"
      />
      <line
        x1="-2.5"
        y1="-2.5"
        x2="2.5"
        y2="2.5"
        stroke-width="0.75"
      />
      <line
        x1="2.5"
        y1="-2.5"
        x2="-2.5"
        y2="2.5"
        stroke-width="0.75"
      />
    </g>

    <g
      opacity="0.08"
      transform="translate(104, 60)"
    >
      <line
        x1="0"
        y1="-3"
        x2="0"
        y2="3"
        stroke-width="1.5"
      />
      <line
        x1="-3"
        y1="0"
        x2="3"
        y2="0"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>
